import { ref } from '@vue/composition-api'

export function common() {

  const week_days = [
    { text: 'Saturday', value: 'Saturday' },
    { text: 'Sunday', value: 'Sunday' },
    { text: 'Monday', value: 'Monday' },
    { text: 'Tuesday', value: 'Tuesday' },
    { text: 'Wednesday', value: 'Wednesday' },
    { text: 'Thursday', value: 'Thursday' },
    { text: 'Friday', value: 'Friday' },
  ]


  const week_ordinaries = [
    { text: 'first week', value: 1 },
    { text: 'second week', value: 2 },
    { text: 'third week', value: 3 },
    { text: 'fourth week', value: 4 },
  ]



  const start_date = ref()
  const end_date = ref()

  const pickerOptions = {
    dateFormat: 'Y-m-d H:i:S',
    defaultDate: [
      new Date().setHours(0, 0, 0),
      new Date().setHours(23, 59, 59, 59),
    ],

    enableTime: true,
    enableSeconds: true,
    defaultHour: 23,
    mode: 'range',
    time_24hr: true,
    onClose: function (selectedDates, dateStr, instance) {
      const date = dateStr.split(' to ')
      start_date.value = date[0]
      end_date.value = date[1]
    },
  }


  const timePickerConfig = {
    enableTime: true,
    noCalendar: true,
    time_24hr: true,
    dateFormat: "H:i:S",
  }


  return {
    week_ordinaries,
    week_days,
    start_date,
    end_date,
    pickerOptions,
    timePickerConfig
  }
}